"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault"),
    _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react")),
    _uiKit = require("@devsta/ui-kit"),
    _SettingRadioButton = _interopRequireDefault(require("./SettingRadioButton"));

require("../../styles/_sharing-settings.scss");

function SharingSettings(a) {
  var b = a.shareSetting,
      c = a.onUpdateShareSetting;
  return _react["default"].createElement("div", {
    className: "share-modal-advanced__container"
  }, _react["default"].createElement(_uiKit.Text, {
    heading5: !0,
    className: "share-modal-advanced__container__header"
  }, "Sharing Settings"), _react["default"].createElement(_uiKit.Icon, {
    name: "info",
    color: "michael",
    size: 15
  }), _react["default"].createElement("div", {
    className: "share-modal-advanced__container__content"
  }, _react["default"].createElement(_SettingRadioButton["default"], {
    onChange: c({
      shareSetting: "NONE"
    }),
    shareSetting: "NONE",
    isSelected: "NONE" === b,
    icon: "padlock",
    title: "Off",
    subtitle: "Only project collaborators can access."
  }), _react["default"].createElement(_SettingRadioButton["default"], {
    onChange: c({
      shareSetting: "ANYONE"
    }),
    shareSetting: "ANYONE",
    isSelected: "ANYONE" === b,
    icon: "web",
    title: "On - anyone with the link",
    subtitle: "Anyone with the link can access."
  }), _react["default"].createElement(_SettingRadioButton["default"], {
    onChange: c({
      shareSetting: "ANYONE_ORG"
    }),
    shareSetting: "ANYONE_ORG",
    isSelected: "ANYONE_ORG" === b,
    icon: "organisation",
    title: "On - anyone in my Organisation",
    subtitle: "Anyone in my Organisation can search and access."
  }), _react["default"].createElement(_SettingRadioButton["default"], {
    onChange: c({
      shareSetting: "ANYONE_ORG_LINK"
    }),
    shareSetting: "ANYONE_ORG_LINK",
    isSelected: "ANYONE_ORG_LINK" === b,
    icon: "link",
    title: "On - anyone in my Organisation with the link",
    subtitle: "Anyone in my Organisation can access."
  })));
}

var _default = (0, _react.memo)(SharingSettings);

exports["default"] = _default;